module.exports = __webpack_public_path__ + "static/media/theme_eventyr.4b76ce9f.jpg";